import {
    apiRequest,
    kgbPeriodCreate,
} from "../../../../../services/adapters/kepegawaian/kgbService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", kgbPeriodCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository